import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import {
  HEALTH_INSURER_LIST_REQUEST,
  HEALTH_INSURER_LIST_RECEIVED,
  HEALTH_INSURER_LIST_ERROR,
  HEALTH_INSURER_LIST_SET_PAGE,
  HEALTH_INSURER_LIST_UNLOAD,
  HEALTH_INSURER_SINGLE_FETCH_REQUEST,
  HEALTH_INSURER_SINGLE_FETCH_SUCCESS,
  HEALTH_INSURER_SINGLE_UPDATE_REQUEST,
  HEALTH_INSURER_SINGLE_UPDATED,
  HEALTH_INSURER_SINGLE_UNLOAD,
} from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const healthInsurerListRequest = () => ({
  type: HEALTH_INSURER_LIST_REQUEST,
});

export const healthInsurerListReceived = (data) => ({
  type: HEALTH_INSURER_LIST_RECEIVED,
  data,
});

export const healthInsurerListError = (error) => ({
  type: HEALTH_INSURER_LIST_ERROR,
  error,
});

export const healthInsurerListSetPage = (page) => ({
  type: HEALTH_INSURER_LIST_SET_PAGE,
  page,
});

export const healthInsurerListUnload = () => ({
  type: HEALTH_INSURER_LIST_UNLOAD,
});

export const healthInsurerListFetch = (page = 1, filters = {}) => {
  return (dispatch) => {
    dispatch(healthInsurerListRequest());
    filters.page = page;
    if (filters.pagination === undefined) {
      filters.pagination = true;
    }
    return requests
      .get(API_ROUTES.HEALTH_INSURER, filters)
      .then((response) => dispatch(healthInsurerListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(healthInsurerListError(error));
      });
  };
};

export const healthInsurerSingleUnload = () => ({
  type: HEALTH_INSURER_SINGLE_UNLOAD,
});

// FETCH SINGLE HEALTH INSURER
export const healthInsurerSingleFetchRequest = () => ({
  type: HEALTH_INSURER_SINGLE_FETCH_REQUEST,
});

export const healthInsurerSingleFetchSuccess = (data) => ({
  type: HEALTH_INSURER_SINGLE_FETCH_SUCCESS,
  data,
});

export const healthInsurerSingleFetch = (healthInsurerId) => {
  return (dispatch) => {
    dispatch(healthInsurerSingleFetchRequest());
    return requests
      .get(`${API_ROUTES.HEALTH_INSURER}/${healthInsurerId}`)
      .then((response) => {
        dispatch(healthInsurerSingleFetchSuccess(response));
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};

// UPDATE HEALTH INSURER
export const healthInsurerSingleUpdateRequest = () => ({
  type: HEALTH_INSURER_SINGLE_UPDATE_REQUEST,
});

export const healthInsurerSingleUpdated = (data) => ({
  type: HEALTH_INSURER_SINGLE_UPDATED,
  data,
});

export const healthInsurerSingleUpdate = (data, healthInsurerId) => {
  return (dispatch) => {
    dispatch(healthInsurerSingleUpdateRequest());
    return requests
      .patch(`${API_ROUTES.HEALTH_INSURER}/${healthInsurerId}`, data)
      .then((response) => dispatch(healthInsurerSingleUpdated(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};
